import React from 'react';
import { createPortal } from 'react-dom';

const ExportPdfFab = ({ onClick, label = 'Export PDF' }) => {
    if (typeof document === 'undefined') return null;

    return createPortal(
        <div className="export-pdf-fab no-print" role="region" aria-label="Export PDF">
            <button type="button" className="export-pdf-fab-btn export-pdf-btn" onClick={onClick}>
                <span aria-hidden="true">⬇️</span>
                <span>{label}</span>
            </button>
        </div>,
        document.body
    );
};

export default ExportPdfFab;
